<template>
<div class="contact-us-page">
    <fancy-header></fancy-header>
    <div class="container">
        <div class="row contact-us-row">
            <div class="col-md-5 col-sm-6 col-xs-6 col-xxs-12 logo-container">
                <div class="img-container">
                    <div class="content">
                        <img src="/src/assets/img/logo.png"/>
                    </div>
                </div>
            </div>
            <div class="col-md-7 col-xs-6 col-xxs-12">
                <div class="info-container">
                        <div>
                            <p><span class="co-orange">بيترونكس</span> للحلول التقنية الشاملة</p>
                        </div>
                         <div>
                            <p>
                                <span class="fa fa-link"></span>اتصل بنا وراسلنا من خلال
                            </p>
                        </div>
                        <div>
                            <p>
                                <span class="fa fa-map-marker"></span><span>سورية - حلب</span></p>
                        </div>
                        <div>
                            <div class="inline-block">
                                <p>
                                    <span class="fa fa-phone"></span><span>021 - 266 42 28</span>
                                </p>
                            </div>
                            <div class="inline-block">•</div>
                            <div class="inline-block">
                                <p>
                                    <span class="fa fa-phone"></span><span>0993 - 327 100</span>
                                </p>
                            </div>
                        </div>
                        <div>
                            <p>
                                <span class="far fa-envelope email-info"></span><span>info@beetronix.com</span>
                            </p>
                        </div>
                       
                </div>
            </div>
        </div>
    </div>
    </div>
  
</template>

<script>
import FancyHeader from '@/components/shared/fancy-header'
export default {
    name:'ContactUs',

    components: {
        FancyHeader
    }
}
</script>

<style lang='scss' scoped>
    @import "src/assets/sass/shared.scss";
    .container{
        padding:50px;
    }
    .contact-us-row{
            & > div{
                @include float-left($dir);
            }
            .logo-container{
                display: flex;
                justify-content: center;
                align-items: center;

                .img-container{
                    width:60%;

                    @include aspect-ratio(3,4);
                    img{
                        width:100%;
                    }
                }
            }
            .info-container{
                @extend .logo-container;
                text-align:center;
                flex-direction: column;
                & > div{
                    text-align:center;
                    margin-top:5px;
                    margin-bottom:5px;
                    p{
                        color:$p-color;
                        font-size:20px;
                        span.fa{
                            @include margin-right(10px,$dir);
                            @include float-left($dir);  
                        }
                    }
                }
                .inline-block{
                    display:inline-block;
                    @include margin-right(15px,$dir);

                    .email-info{
                        margin: 4px 8px;
                        direction: $dir;
                        float: right;
                    }
                }
            }
  
    }
    
     
</style>



// WEBPACK FOOTER //
// src/components/contact-us.vue